import * as types from 'manuals/actions/types'

const initialState = {
    selectedCategory: null,
    categoryList: [],
    selectedManual: null,
    manualList: [],
    isLoading: true,
    hasErrors: false,
    errors: [],
    displaySearchResults: false,
    searchText: ''
}

export default function manuals(state = initialState, action) {
    switch (action.type) {
        case types.LOAD_MANUAL_CATEGORIES:
            return {
                ...state,
                isLoading: true
            }
        case types.LOAD_MANUAL_CATEGORIES_ERROR:
            return {
                ...state,
                isLoading: false,
                hasErrors: true,
                errors: action.errors
            }
        case types.LOAD_MANUAL_CATEGORIES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasErrors: false,
                categoryList: action.categoryList
            }
        case types.SELECT_MANUAL_CATEGORY:
            return {
                ...state,
                selectedCategory: action.selectedCategory,
                selectedManual: null
            }
        case types.DESELECT_MANUAL_CATEGORY:
            return {
                ...state,
                selectedCategory: null,
                manualList: []
            }
        case types.LOAD_MANUAL_LIST:
        case types.SEARCH_MANUAL_LIST:
            return {...state, isLoading: true}
        case types.SET_SEARCH_TEXT:
            return {...state, searchText: action.searchText}
        case types.LOAD_MANUAL_LIST_ERROR:
        case types.SEARCH_MANUAL_LIST_ERROR:
            return {...state, isLoading: false, hasErrors: true}
        case types.LOAD_MANUAL_LIST_SUCCESS:
            return {
                ...state,
                hasErrors: false,
                isLoading: false,
                manualList: action.manualList,
                displaySearchResults: false
            }
        case types.SEARCH_MANUAL_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasErrors: false,
                manualList: action.manualList,
                displaySearchResults: true
            }
        case types.SEARCH_MANUAL_LIST_RESET:
            return {
                ...state, isLoading: false,
                displaySearchResults: false,
                searchText: ''
            }
        case types.SELECT_MANUAL:
            return {
                ...state,
                selectedManual: action.manual
            }
        case types.DESELECT_MANUAL:
            return {
                ...state,
                selectedManual: null
            }
        case types.CREATE_MANUAL_CATEGORY:
            return {
                ...state
            }
        case types.CREATE_MANUAL_CATEGORY_SUCCESS:
            return {
                ...state
            }
        case types.CREATE_MANUAL_CATEGORY_ERROR:
            return {
                ...state,
                hasErrors: true,
                errors: action.errors
            }
        case types.UPDATE_MANUAL_CATEGORY:
            return {
                ...state,
                selectedCategory: action.category
            }
        case types.UPDATE_MANUAL_CATEGORY_SUCCESS:
            return {
                ...state
            }
        case types.UPDATE_MANUAL_CATEGORY_ERROR:
            return {
                ...state,
                hasErrors: true,
                errors: action.errors
            }
        case types.DELETE_MANUAL_CATEGORY:
            return {
                ...state
            }
        case types.DELETE_MANUAL_CATEGORY_SUCCESS:
            return {
                ...state,
                categoryList: [],
                manualList: [],
                selectedCategory: null,
                selectedManual: null
            }
        case types.DELETE_MANUAL_CATEGORY_ERROR:
            return {
                ...state,
                hasErrors: true,
                errors: action.errors
            }
        case types.UPDATE_MANUAL:
            return {
                ...state,
                selectedManual: action.template
            }
        case types.SAVE_MANUAL_SUCCESS:
            return {
                ...state,
                manualList: action.manualList
            }
        case types.DELETE_MANUAL_ERROR:
            return {
                ...state,
                errors: action.errors
            }
        default:
            return state
    }
}
